import { useEffect, useState } from "react";
import { API_BASE, getToken, type Message } from "../api";

interface Props { message: Message; }

export default function VoiceBubble({ message }: Props) {
  const [url, setUrl] = useState<string | null>(null);
  const [showTranscript, setShowTranscript] = useState(false);

  useEffect(() => {
    let cleanup: string | null = null;
    (async () => {
      const res = await fetch(`${API_BASE}/messages/${message.id}/audio`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      if (!res.ok) return;
      const blob = await res.blob();
      const u = URL.createObjectURL(blob);
      cleanup = u;
      setUrl(u);
    })();
    return () => { if (cleanup) URL.revokeObjectURL(cleanup); };
  }, [message.id]);

  const dur = message.audio_duration_sec || 0;
  const m = Math.floor(dur / 60);
  const s = dur % 60;
  const durStr = m > 0 ? `${m} min ${s} s` : `${s} s`;

  const summary = message.audio_summary?.trim();
  const transcript = message.audio_transcript?.trim();
  const hasSummary = !!summary;
  const hasTranscript = !!transcript;

  return (
    <div>
      <div className="tiny" style={{ marginBottom: 4 }}>🎤 Vocal · {durStr}</div>
      {url ? (
        <audio src={url} controls preload="metadata" style={{ width: "100%", maxWidth: 300, height: 36 }} />
      ) : (
        <div className="muted">Chargement…</div>
      )}

      {hasSummary && (
        <div style={{
          marginTop: 8,
          padding: "8px 10px",
          background: "var(--blue-tint)",
          borderLeft: "3px solid var(--blue)",
          borderRadius: 4,
          fontSize: "0.88rem",
          color: "var(--ink)",
          fontStyle: "italic",
        }}>
          {summary}
        </div>
      )}
      {!hasSummary && hasTranscript && (
        <div style={{ marginTop: 8, fontSize: "0.88rem", fontStyle: "italic", color: "var(--ink-mute)" }}>
          {transcript}
        </div>
      )}

      {hasSummary && hasTranscript && (
        <button
          className="tiny"
          style={{ color: "var(--blue)", marginTop: 6 }}
          onClick={() => setShowTranscript((v) => !v)}
        >
          {showTranscript ? "Masquer la transcription" : "Voir la transcription complète"}
        </button>
      )}
      {showTranscript && hasTranscript && (
        <div style={{ marginTop: 6, fontSize: "0.85rem", color: "var(--ink-mute)", whiteSpace: "pre-wrap" }}>
          {transcript}
        </div>
      )}
      {!hasTranscript && url && (
        <div className="tiny" style={{ marginTop: 6 }}>Transcription en cours…</div>
      )}
    </div>
  );
}
